import React from "react";
import CreditCardForm from "../BookingFlow/CreditCardForm";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import DateHelper from "../DateHelper/DateHelper";
import TermsAndConditions from "../TermsAndConditions/TermsAndConditions";
import numeral from "numeral";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  ElementsConsumer,
  CardElement,
} from "@stripe/react-stripe-js";
import { differenceInSeconds } from 'date-fns';

class PortalReservationCheckout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      balance_due: this.getBalanceDue(),
      card: {},
      cards: this.props.reservation_segment?.customer?.cards || [],
      displayNewCustomerCard: false,
      errors: null,
      success: null,
      loading: false,
      payment_card_id: '',
      checkout_permitted: this.isCheckoutPermitted(),
      cannot_checkout_reason: this.getCannotCheckoutReason(),
    };

    this.onCheckout = this.onCheckout.bind(this);
    this.onAddCard = this.onAddCard.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeCardInput = this.onChangeCardInput.bind(this);
  }

  async componentDidMount() {
    // Always show confirmation, don't auto-checkout
    if (this.state.balance_due > 0) {
      const stripe = await loadStripe(this.props.public_gateway_key);
      this.setState({ stripe: stripe });
    }
  }

  render() {
    return (
      <div className="PortalReservationCheckout">
        {this.renderModalButtons()}
        {this.renderErrors()}
        {this.state.success ? (
          this.renderSuccess()
        ) : (
          <div>
            {this.renderForm()}
          </div>
        )}
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  renderForm() {
    const { balance_due, checkout_permitted, cannot_checkout_reason } = this.state;
    
    if (!checkout_permitted) {
      return this.renderCannotCheckout(cannot_checkout_reason);
    } else {
      // Always show confirmation for checkout
      let explanationText;
      if (balance_due > 0) {
        explanationText = I18n.t("checkout_requires_payment", {
          amount: this.formatCurrency(balance_due),
        });
      } else if (balance_due < 0) {
        explanationText = I18n.t("checkout_with_refund", {
          refund: this.formatCurrency(Math.abs(balance_due)),
        });
      } else {
        explanationText = I18n.t("checkout_no_balance");
      }
      
      return this.renderConfirmation(explanationText);
    }
  }

  renderPayment() {
    return (
      <div className="room-type" style={{ marginTop: "15px" }}>
        <div className="row">
          <div className="col-sm-3">
            <div
              className="panel panel-default payment-amount-explainer-panel"
              style={{ margin: 0 }}
            >
              <div className="panel-body">
                <label style={{ color: "#777", marginBottom: "0px" }}>
                  {I18n.t("payment_amount")}
                </label>
                <h3 style={{ marginTop: "4px", marginBottom: "0px" }}>
                  {this.formatCurrency(this.state.balance_due)}
                </h3>
              </div>
            </div>
          </div>
          <div className="col-sm-9">
            {this.state.stripe ? (
              <Elements
                stripe={this.state.stripe}
                options={{
                  locale:
                    navigator.languages && navigator.languages.length
                      ? navigator.languages[0]
                      : navigator.language,
                }}
              >
                <ElementsConsumer>
                  {({ stripe, elements }) => [
                    this.renderCardsOrCardForm("payment_card"),
                    this.renderModalButtons(elements),
                  ]}
                </ElementsConsumer>
              </Elements>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  renderCardsOrCardForm(card_type_name) {
    if (this.state.displayNewCustomerCard || this.state.cards.length === 0) {
      return (
        <div className="PaymentMethod">
          <div className="card" style={{ padding: 0 }}>
            <CreditCardForm
              card={this.state.card}
              customer={this.props.reservation_segment.customer}
              onChangeCardInput={this.onChangeCardInput}
              additionalClasses="container"
            />
          </div>
          {this.state.cards.length > 0 ? (
            <p>
              <a href="#" onClick={this.onAddCard}>
                {I18n.t(
                  !this.state.displayNewCustomerCard
                    ? "add_new_card"
                    : "use_existing_cards"
                )}
              </a>
            </p>
          ) : null}
        </div>
      );
    } else {
      var cards = this.state.cards.map((card) => {
        return (
          <div
            className={
              "card well " +
              (this.state[card_type_name + "_id"] == card.id
                ? "card-selected"
                : "")
            }
            key={card.id}
          >
            <label
              style={{ display: "flex", alignItems: "center", marginBottom: 0 }}
            >
              <input
                type="radio"
                name={card_type_name + "_id"}
                value={card.id}
                checked={this.state[card_type_name + "_id"] == card.id}
                onChange={this.onChange}
              />
              <span className={"credit-card-icon small " + card.brand}></span>
              <span className="card-detail-text">
                {I18n.t("ending_in").toLowerCase()}{" "}
                <strong>{card.last_4}</strong>
              </span>
            </label>
          </div>
        );
      });

      return (
        <div className="PaymentMethod">
          <div className="cards">{cards}</div>
          <p>
            <a href="#" onClick={this.onAddCard}>
              {I18n.t(
                !this.state.displayNewCustomerCard
                  ? "add_new_card"
                  : "use_existing_cards"
              )}
            </a>
          </p>
        </div>
      );
    }
  }

  renderCannotCheckout(reason) {
    return (
      <div>
        <div className="alert alert-warning text-center">
          <p
            style={{
              fontWeight: "bold",
              color: "red",
              marginBottom: 0,
              padding: "15px 0",
              textAlign: "center",
            }}
          >
            {I18n.t("cannot_checkout_reservation_because", {
              reason: reason,
            })}
          </p>
        </div>
        <TermsAndConditions reservation_segments={[this.props.reservation_segment]} />
      </div>
    );
  }

  renderConfirmation(explanationText) {
    return (
      <div>
        <div className="alert alert-warning" style={{ marginBottom: 0 }}>
          <h4 className="text-center">
            {I18n.t(
              "are_you_sure_you_want_to_checkout_this_reservation_segment",
              {
                room_name: this.props.reservation_segment.room_type.name,
                guests: this.props.guests_str,
                start_date: DateHelper.printDateToScreen(
                  this.props.reservation_segment.check_in_date,
                  this.props.date_format
                ),
                end_date: DateHelper.printDateToScreen(
                  this.props.reservation_segment.check_out_date,
                  this.props.date_format
                ),
              }
            )}
          </h4>
          <h4
            className="text-center"
            style={{ marginTop: "15px", marginBottom: "15px", fontSize: '20px' }}
            dangerouslySetInnerHTML={{ __html: explanationText }}
          ></h4>
          <p
            style={{
              fontWeight: "bold",
              color: "red",
              marginBottom: 0,
              textAlign: "center",
            }}
          >
            {I18n.t("checkout_is_final")}
          </p>
        </div>
        <TermsAndConditions reservation_segments={[this.props.reservation_segment]} />
        {this.state.balance_due > 0 ? this.renderPayment() : null}
      </div>
    );
  }

  renderErrors() {
    if (this.state.errors && this.state.errors.length > 0) {
      var errors = this.state.errors.map((error) => {
        return <li key={error}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderSuccess() {
    if (this.state.success) {
      return (
        <div
          className="alert alert-success text-center"
          style={{ maxWidth: "444px", margin: "5px auto" }}
        >
          <h4 className="text-center" style={{ marginBottom: "10px" }}>
            {I18n.t("checkout_successful")}
          </h4>
          <p style={{ marginBottom: 0 }}>
            {this.state.success || I18n.t("reservation_has_been_checked_out_successfully")}
          </p>
        </div>
      );
    }
  }

  renderModalButtons(elements) {
    if (this.state.success || !this.state.checkout_permitted) {
      return (
        <ModalButtons
          loading={this.state.loading}
          buttons={[
            {
              name: I18n.t("done"),
              button_classes: ["primary"],
              html_attributes: ['data-dismiss="modal"'],
            },
          ]}
        />
      );
    } else {
      return (
        <ModalButtons
          loading={this.state.loading}
          buttons={[
            {
              name: I18n.t("back"),
              button_classes: ["link"],
              html_attributes: ['data-dismiss="modal"'],
            },
            {
              name: I18n.t("check_out_this_room"),
              button_classes: ["primary"],
              onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
                this.onCheckout(elements);
              },
            },
          ]}
        />
      );
    }
  }

  /**
   * Change handlers
   */

  onAddCard() {
    var state = {
      displayNewCustomerCard: !this.state.displayNewCustomerCard,
      card: { name_on_card: "" },
      payment_card_id: "",
    };

    this.setState(state);
  }

  onChange(e) {
    var { state } = this;
    state[e.target.name] = e.target.value;

    this.setState(state);
  }

  onChangeCardInput(e) {
    var { card = {} } = this.state;
    card[e.target.name] = e.target.value;
    this.setState({ card: card });
  }

  onCheckout(elements) {
    var self = this;

    this.setState({ loading: true });

    this.saveCardAPI(elements)
      .then((data) => {
        if (data && data.errors) {
          this.setState({ loading: false, errors: data.errors });
        } else {
          var card = data.success;
          var { cards } = this.state;
          if (card) {
            cards.unshift(card);
          }
          this.setState(
            {
              cards: cards,
              payment_card_id: card ? card.id : this.state.payment_card_id,
              card: {},
            },
            () => {
              self
                .createPaymentAPI()
                .then((data) => {
                  if (data && data.errors) {
                    self.setState({ loading: false, errors: data.errors });
                  } else {
                    $.ajax({
                      url: this.props.check_out_path,
                      type: "POST",
                      data: {
                        reservation_segment_id: this.props.reservation_segment.id,
                      },
                    }).done(function (data) {
                      self.setState({
                        loading: false,
                        errors: data.errors || null,
                        success: data.success || I18n.t("reservation_has_been_checked_out_successfully"),
                      });
                      window.refresh_data();
                    });
                  }
                })
                .catch((response) => {
                  self.setState({ loading: false, errors: response });
                });
            }
          );
        }
      })
      .catch((response) => {
        this.setState({ loading: false, errors: response });
      });
  }

  /**
   * API endpoint functions
   */

  saveCardAPI(elements) {
    return new Promise(async (resolve, reject) => {
      if (this.state.balance_due <= 0 || this.state.payment_card_id) {
        // No payment required (or using a saved card), so no need to save new card
        resolve({});
        return;
      }
      
      if (!this.state.card || Object.keys(this.state.card).length === 0) {
        reject([I18n.t("select_or_enter_card")]);
      } else if (
        !this.state?.card?.name_on_card ||
        /\d/.test(this.state?.card?.name_on_card)
      ) {
        reject([I18n.t("name_on_card_error")]);
      } else {
        var stripe = this.state.stripe;
        var cardElement = elements.getElement(CardElement);

        if (!stripe || !elements) {
          console.log(
            "We should never hit this! Either Stripe or Elements is not loaded!"
          );
          return;
        }

        const result = await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
          billing_details: {
            name: this.state.card.name_on_card,
          },
        });

        if (result.error) {
          reject([result.error.message]);
        } else if (result.paymentMethod) {
          $.ajax({
            url: this.props.customer_store_card_path,
            type: "POST",
            data: {
              customer_id: this.props.reservation_segment.customer.id,
              payment_token: result.paymentMethod,
            },
          }).done(function (data) {
            resolve(data);
          });
        } else {
          console.log("should not hit here - potential async issue");
        }
      }
    });
  }

  createPaymentAPI() {
    return new Promise((resolve, reject) => {
      if (this.state.balance_due <= 0) {
        // No payment required, so no need to create a payment
        resolve({});
        return;
      }

      $.ajax({
        url: this.props.create_payment_path,
        type: "POST",
        data: {
          reservation_segment_id: this.props.reservation_segment.id,
          card_id: this.state.payment_card_id,
          amount: this.state.balance_due,
        },
      }).done(function (data) {
        resolve(data);
      });
    });
  }

  /**
   * Helper functions
   */

  getBalanceDue() {
    var balance_due = 0

    if (this.props.reservation_segment && this.props.reservation_segment.folios && this.props.reservation_segment.folios.length > 0) {
      for (var i = 0, ilen = this.props.reservation_segment.folios.length; i < ilen; i++) {
        balance_due = balance_due + this.props.reservation_segment.folios[i].balance
      }
    }

    return balance_due
  }

  isCheckoutPermitted() {
    if (this.props.reservation_segment) {
      var today = new Date(DateHelper.today());
      var check_out_date = DateHelper.parseDateFromBackend(this.props.reservation_segment.check_out_date);
      var check_out_diff = differenceInSeconds(today, check_out_date) !== 0 ? differenceInSeconds(today, check_out_date) / 86400 : 0;

      if (this.props.reservation_segment.status === 'checked_in' && check_out_diff <= 0) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  getCannotCheckoutReason() {
    if (!this.props.reservation_segment) {
      return I18n.t('reservation_not_found');
    }

    if (this.props.reservation_segment.status !== 'checked_in') {
      return I18n.t('cannot_checkout_not_checked_in');
    }

    var today = new Date(DateHelper.today());
    var check_out_date = DateHelper.parseDateFromBackend(this.props.reservation_segment.check_out_date);
    var check_out_diff = differenceInSeconds(today, check_out_date) !== 0 ? differenceInSeconds(today, check_out_date) / 86400 : 0;

    if (check_out_diff > 0) {
      return I18n.t('cannot_checkout_past_checkout_date');
    }

    return I18n.t('cannot_checkout_unknown_reason');
  }

  formatCurrency(num) {
    return (
      I18n.t("number.currency.format.unit") +
      numeral(num / 100).format(
        "0" + I18n.t("number.currency.format.delimiter") + "0.00"
      )
    );
  }
}

export default PortalReservationCheckout;
